import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { IoSearch } from "react-icons/io5";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { Table, Pagination } from "react-bootstrap";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import filter from "../../assets/filter.svg";
import sort from "../../assets/sort.svg";
import NewTransactions from "../../component/comman/NewTransactions";
import Popup from "reactjs-popup";
import { IoClose } from "react-icons/io5";
import OtpInput from "react-otp-input";
import { IoMdMore } from "react-icons/io";
import ToastMsg from "../../component/comman/ToastMsg";
import { GoEyeClosed } from "react-icons/go";
import pdf from "../../assets/pdf.svg";
import { FaCheckCircle } from 'react-icons/fa';

import {
  dashboardList,
  deleteTransactions,
  updateTransactions,
  verifyPin,
  updateCustomers,
  getCustomers,
  bookMark
} from "../../services/ApiServices";
import $ from 'jquery';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap-daterangepicker';
import moment from 'moment';
import { downloadBase64Pdf } from "../../auth/utils/Utils";
import { FaBookmark } from 'react-icons/fa';

function CustomerTransactions() {
  const [otp, setOtp] = useState("");
  const [open, setOpen] = useState(false);
  const [userName, setUserName] = useState("false");
  const [searchParams, setSearchParams] = useSearchParams();
  const [name, setName] = useState("");
  const closeModal = () => {
    setOpen(false);
    setSelectedTransaction(null);
  };
  const [open2, setOpen2] = useState(false);
  const [isProfilePopUp, setIsProfilePopUp] = useState(false);
  const closeModal2 = () => setOpen2(false);
  const userId = searchParams.get('userId');
  const company = searchParams.get('company');
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [isNewTransactionPopupOpen, setIsNewTransactionPopupOpen] =
    useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [date, setDate] = useState("");
  const [actionType, setActionType] = useState("update");
  const [details, setDetails] = useState("");
  const [debitValue, setDebitValue] = useState("");
  const [creditValue, setCreditValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [summary, setSummary] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [order, setOrder] = useState("-transaction_date");
  const [transationType, setTransationType] = useState("");
  const [hideOne, setHideOne] = useState(() => {
    const storedValue = localStorage.getItem('hideSeven');
    return storedValue === 'true' ? true : false;
  });
  const [hideTwo, setHideTwo] = useState(() => {
    const storedValue = localStorage.getItem('hideEight');
    return storedValue === 'true' ? true : false;
  });
  const [hideThree, setHideThree] = useState(() => {
    const storedValue = localStorage.getItem('hideNine');
    return storedValue === 'true' ? true : false;
  });
  const [isHovered, setIsHovered] = useState(false);

  const [pageInfo, setPageInfo] = useState({
    current_page: 1,
    total_pages: 1,
    has_next: false,
    has_previous: false,
  });
  useEffect(() => {
    if (selectedTransaction) {
      setDate(selectedTransaction.transaction_date);
      setCustomerId(selectedTransaction.id || "");
      setDetails(selectedTransaction.details || "");
      setDebitValue(
        selectedTransaction.transaction_type === "debit"
          ? selectedTransaction.transaction_amount
          : ""
      );
      setCreditValue(
        selectedTransaction.transaction_type === "credit"
          ? selectedTransaction.transaction_amount
          : ""
      );
    }
  }, [selectedTransaction]);

  useEffect(() => {
    setOtp("")
  }, [open2]);
  const [formData, setFormData] = useState({
    company: "",
    name: "",
    phone: "",
    email: "",
    details: "",
  });

  const updateUrlParams = (new_name) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('name', new_name);
    searchParams.set('company', company);
    window.history.pushState({}, '', `${window.location.pathname}?${searchParams.toString()}`);
    setName(new_name)
    window.location.reload();
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };
  const isValidPhone = (phone) => {
    return phone.toString().length === 10;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleCustomerData = () => {
    const customerData = {

      name: formData.name,
      email: formData.email,
      mobile_no: formData.phone,
      details: formData.details,
      company: company
    };
    updateCustomers({ customerData, userId }).then((res) => {
      closeProfile();
      let name = formData.name
      setFormData({
        company: "1",
        name: "",
        phone: "",
        email: "",
        details: "",
      });
      console.log(res);
      ToastMsg("Successfully Update", "success");
      updateUrlParams(name)
    })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };
  useEffect(() => {
    getCustomerData();
    const searchParams = new URLSearchParams(window.location.search);
    const name = searchParams.get('name')
    setName(name)

  }, []);

  const getCustomerData = () => {

    getCustomers(userId).then((res) => {

      console.log('res', res?.data);
      let customerData = res?.data;
      setFormData({
        name: res?.data?.name,
        phone: res?.data?.mobile_no,
        email: res?.data?.email,
        details: customerData?.details,
      })
      console.log(res);
      // ToastMsg(res?.data?.message, "success");
    })
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  const handleUpdateTransaction = () => {
    const updatedData = {
      transaction_date: date,
      customer: customerId,
      transaction_type: debitValue ? "debit" : "credit",
      transaction_amount: debitValue || creditValue,
      details: details,
    };
    updateTransactions(updatedData)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Transaction updated successfully", "success");
          closeModal2();
          const dateRange = $('input[name="daterange"]').data('daterangepicker');
          const startDate = dateRange.startDate.format('YYYY-MM-DD');
          const endDate = dateRange.endDate.format('YYYY-MM-DD');
          getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm });
        } else {
          ToastMsg("Failed to update transaction", "error");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        ToastMsg("Something went wrong", "error");
      });
  };

  const getCustomersDetails = useCallback(
    (params = {}) => {
      const queryParams = { ...params, customer_id: userId, filter_value: searchTerm, all_transaction: "true", page_type: "customer", page_num: currentPage, all_transaction: true, per_page_data: itemsPerPage };
      if (!queryParams.start_date) {
        console.log("start_date is not present, skipping API call.");
        return;
      }
      if (!queryParams.end_date) {
        console.log("end_date is not present, skipping API call.");
        return;
      }
      dashboardList(queryParams)
        .then((res) => {
          console.log("API Response:", res.data.data);
          if (res.status === 200 && Array.isArray(res?.data?.data)) {
            setSummary(res?.data?.transaction_summary);
            setCustomers(res?.data?.data);
            setFilteredCustomers(res?.data?.data);
            setUserName(res?.data?.data[0]?.customer__name);
            setPageInfo(res?.data?.page_info);
            setTotalPages(res?.data?.page_info.total_pages);

          } else {
            let file_name = `${name}.pdf`
            downloadBase64Pdf(res?.data?.pdf_base64, file_name);
          }
        })
        .catch((err) => {
          console.error("API Error:", err);
          if (err.response?.status === 401) {
            navigate("/");
          }
          let error = err?.response?.data?.error || "something went wrong";
          ToastMsg(error, "error");
          setCustomers([]);
          setFilteredCustomers([]);
        });
    },
    [navigate, searchTerm, userId, currentPage, itemsPerPage]
  );


  useEffect(() => {
    const today = moment().format('YYYY-MM-DD');
    getCustomersDetails({
      start_date: "2050-12-12", end_date: "2000-12-12"
    }, [getCustomersDetails]);

    const handleDateRangeChange = (start, end) => {
      const startDate = start.format('YYYY-MM-DD');
      const endDate = end.format('YYYY-MM-DD');
      getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, order: order, transaction_type: transationType });
    };

    $('input[name="daterange"]').daterangepicker({
      opens: 'left',
      startDate: moment('2000-01-01'),
      endDate: moment(),
      maxDate: moment(),
      locale: {
        format: 'DD/MM/YYYY',
      },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      },
    }, handleDateRangeChange);

    return () => {
      $('input[name="daterange"]').daterangepicker('destroy');
    };
  }, [getCustomersDetails]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const dateRange = $('input[name="daterange"]').data('daterangepicker');
      const startDate = dateRange.startDate.format('YYYY-MM-DD');
      const endDate = dateRange.endDate.format('YYYY-MM-DD');
      getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm });
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, getCustomersDetails]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      getCustomersDetails();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm, getCustomersDetails]);

  useEffect(() => {
    setFilteredCustomers(customers);
    setTotalPages(Math.ceil(customers.length / itemsPerPage));
  }, [customers, itemsPerPage]);

  const handleSort = (sortOrder) => {
    const params = { order: sortOrder };
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');
    setOrder(sortOrder);
    getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, order: sortOrder });
  };
  const handleAccounts = (sortOrder) => {
    const params = { transaction_type: sortOrder };
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');
    setTransationType(sortOrder);
    getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, order: order, transaction_type: sortOrder });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const openNewTransactionPopup = () => {
    setIsNewTransactionPopupOpen(true);
  };

  const closeNewTransactionPopup = () => {
    setIsNewTransactionPopupOpen(false);
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');
    getCustomersDetails({ start_date: startDate, end_date: endDate });
  };

  const handleVerifyPin = (e) => {
    e.preventDefault();
    const data = {
      user_pin: otp,
    };
    verifyPin(data)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Pin Verify successfully!", "success");
          if (actionType === "update") {
            handleUpdateTransaction();
          } else if (actionType === "delete") {
            handleDeleteTransaction();
          }
          setOpen2(true);
          getCustomersDetails();
        } else {
          console.error("Failed to update details:", res?.data);
          ToastMsg("Pin Verify Failed", "error");
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  const handleDeleteTransaction = () => {
    const updatedData = {
      customer: customerId,
    };
    deleteTransactions(updatedData)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Transaction Deleted successfully", "success");
          closeModal2();
          const dateRange = $('input[name="daterange"]').data('daterangepicker');
          const startDate = dateRange.startDate.format('YYYY-MM-DD');
          const endDate = dateRange.endDate.format('YYYY-MM-DD');
          getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, order: order, transaction_type: transationType });
        } else {
          ToastMsg("Failed to update transaction", "error");
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        ToastMsg("Something went wrong", "error");
      });
  };

  useEffect(() => {
    getCustomersDetails();
  }, [getCustomersDetails, navigate, searchTerm, userId, currentPage, itemsPerPage]);

  const handleExport = () => {
    const dateRange = $('input[name="daterange"]').data('daterangepicker');
    const startDate = dateRange.startDate.format('YYYY-MM-DD');
    const endDate = dateRange.endDate.format('YYYY-MM-DD');
    getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, order: order, transaction_type: transationType, is_pdf: true });
  };

  const handleProfile = () => {
    setIsProfilePopUp(true);
  }
  const closeProfile = () => {
    setIsProfilePopUp(false);
  }

  const doBookMark = () => {
    bookMark(userId).then((res) => {
      if (res.status === 200) {
        ToastMsg("Marked Successfully", "success");
        const dateRange = $('input[name="daterange"]').data('daterangepicker');
        const startDate = dateRange.startDate.format('YYYY-MM-DD');
        const endDate = dateRange.endDate.format('YYYY-MM-DD');
        getCustomersDetails({ start_date: startDate, end_date: endDate, filter_value: searchTerm, order: order, transaction_type: transationType });
      } else {
        ToastMsg("Failed to Marked", "error");
      }
    })
      .catch((err) => {
        console.error("API Error:", err);
        ToastMsg("Something went wrong", "error");
      });

  }

  return (
    <>
      <div className="dasboard-content journal">
        <div className="journal-header">
          <NewTransactions
            isOpenNow={isNewTransactionPopupOpen}
            onCloseNow={closeNewTransactionPopup}
            onTransactionSuccess={() => getCustomersDetails()}
            name={name}
            userId={userId}
          />
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="search-sc" style={{ backgroundColor: "unset" }}>
              <form className="d-flex align-items-center">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <IoSearch className="search-icon" />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="daterange"
                    className="form-control date-range"
                    placeholder="All Time"
                  />
                </div>
                <div
                  name="mark"
                  className="form-control"
                  style={{
                    borderRadius: 12,
                    width: 'fit-content',
                    display: 'inline-flex',
                    alignItems: 'center',
                    marginLeft: '20px',
                    height: '35px',
                    borderColor: '#007aff',
                    cursor: 'pointer',
                    backgroundColor: isHovered ? '#007aff' : 'transparent',
                  }}
                  onClick={doBookMark}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <span style={{ color: isHovered ? 'white' : 'black' }}>Mark</span>
                  <FaBookmark size={13} color="silver" style={{ marginLeft: '5px' }} />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="name-initial" style={{ display: 'flex' }}>
              <h3 className="d-flex align-items-center"><p>{name?.[0]}</p>{name} &nbsp;<FaRegEdit onClick={handleProfile} style={{ cursor: "pointer" }} /></h3>
            </div>
            <div className="cr-dr">
              <div className="row">
                <div className="colm green">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-flex align-items-center">
                      Debit <TiArrowSortedUp />
                    </p>
                    <GoEyeClosed onClick={() => {
                      setHideOne((hideOne) => {
                        const newValue = !hideOne;
                        localStorage.setItem('hideSeven', newValue.toString());
                        return newValue;
                      });
                    }} />
                  </div>
                  <h2 className={hideOne ? "active" : ""}>€ {summary?.total_debit || 0}</h2>
                </div>
                <div className="colm red">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="d-flex align-items-center">
                      Credit <TiArrowSortedDown />
                    </p>
                    <GoEyeClosed onClick={() => {
                      setHideTwo((hideTwo) => {
                        const newValue = !hideTwo;
                        localStorage.setItem('hideEight', newValue.toString());
                        return newValue;
                      });
                    }} />
                  </div>
                  <h2 className={hideTwo ? "active" : ""}>€ {summary?.total_credit || 0}</h2>
                </div>
                <div className="colm blue">
                  <div className="d-flex align-items-center justify-content-between">
                    <p>
                      Balance
                    </p>
                    <GoEyeClosed onClick={() => {
                      setHideThree((hideThree) => {
                        const newValue = !hideThree;
                        localStorage.setItem('hideNine', newValue.toString());
                        return newValue;
                      });
                    }} />
                  </div>
                  <h2 className={hideThree ? "active" : ""}>€ {summary?.net_transaction || 0}</h2>
                </div>
                <div className="colm button-dv">
                  <button className="btn" onClick={openNewTransactionPopup}>+ New <span>Transaction</span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <div className="card-header d-flex align-items-center justify-content-between">
              <h5>
                All Transaction
              </h5>
              <div className="filter d-flex align-items-center">
                <div className="link d-flex align-items-center cusr-ptr" onClick={() => handleExport(true)}>
                  <img src={pdf} alt="icon" width={24} height={21} />
                  <span>Export PDF</span>
                </div>
                <div className="dropdown">
                  <button className="flex align-items-center">
                    <span>Sort</span>
                    <img src={sort} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleSort("-is_marked")}>Marked</li>
                      <li onClick={() => handleSort("customer__name")}>Name <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-customer__name")}>Name <TiArrowSortedUp /></li>
                      <li onClick={() => handleSort("transaction_date")}>Date <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-transaction_date")}>Date <TiArrowSortedUp /></li>
                      <li onClick={() => handleSort("balance")}>Balance <TiArrowSortedDown /></li>
                      <li onClick={() => handleSort("-balance")}>Balance <TiArrowSortedUp /></li>
                    </ul>
                  </div>
                </div>
                <div className="dropdown" style={{ marginLeft: "10px" }}>
                  <button className="flex align-items-center">
                    <span>Accounts</span>
                    <img src={filter} alt="icon" width={18} height={15} />
                  </button>
                  <div className="subMenu">
                    <ul>
                      <li onClick={() => handleAccounts("")}>All</li>
                      <li onClick={() => handleAccounts("credit")}>Credit</li>
                      <li onClick={() => handleAccounts("debit")}>Debit</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <Table className="table-centered table-striped table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ cursor: "pointer" }}>Date</th>
                    <th style={{ cursor: "pointer" }}>Details</th>
                    <th style={{ cursor: "pointer" }}>Debit & Credit</th>
                    <th style={{ cursor: "pointer" }}>Balance</th>
                    <th style={{ cursor: "pointer" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCustomers.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    filteredCustomers.map((user, index) => (
                      <tr key={index}>
                        <td>{user.transaction_date}</td>
                        <td className="detail-td">{user.details}</td>
                        <td
                          className={
                            user.transaction_type === "debit" ? "green" : "red"
                          }
                        >
                          {user.transaction_type === "debit" ? (
                            <TiArrowSortedUp />
                          ) : (
                            <TiArrowSortedDown />
                          )}
                          {user.transaction_amount}
                        </td>
                        <td>
                          {user.balance || "00.00"}
                          {user.is_marked && (
                            <FaCheckCircle size={12} color="#007aff" style={{ marginLeft: '5px' }} />
                          )}
                        </td>
                        <td>
                          <div className="dropdown">
                            <IoMdMore />
                            <div className="subMenu">
                              <ul>
                                <li
                                  onClick={() => {
                                    setSelectedTransaction(user);
                                    setOpen(true);
                                  }}
                                >
                                  Edit
                                </li>
                                <li
                                  onClick={() => {
                                    setSelectedTransaction(user);
                                    setActionType("delete");
                                    setOpen2((open2) => !open2);
                                  }}
                                >
                                  Delete
                                </li>
                              </ul>
                            </div>
                          </div>
                          <FaRegEdit
                            onClick={() => {
                              setSelectedTransaction(user);
                              setOpen(true);
                            }}
                          />
                          <RiDeleteBin5Fill
                            onClick={() => {
                              setSelectedTransaction(user);
                              setActionType("delete");
                              setOpen2((open2) => !open2);
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center border-top pagination-wrapper">
              <div className="text-muted small">
                {(currentPage - 1) * itemsPerPage + 1}-
                {10 * (currentPage - 1) + filteredCustomers.length}
                {" "}of {pageInfo.total_data || "0"}
              </div>
              <div className="d-flex align-items-center">
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="itemsPerPage">Rows per page:</label>
                  <select
                    id="itemsPerPage"
                    className="form-control"
                    value={itemsPerPage}
                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  <MdOutlineKeyboardArrowDown />
                </div>
                <Pagination size="sm" className="pagination-rounded mb-0">
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  />
                  <p>
                    <span>{currentPage}</span>/{pageInfo.total_pages}
                  </p>
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === pageInfo.total_pages}
                  />
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup
        open={open}
        closeOnDocumentClick={false}
        onClose={() => {
          setOpen(false);
          setSelectedTransaction(null);
        }}
        className="new-user journal-pop"
      >
        <div className="card">
          <div className="card-body">
            <div className="flex align-items-center justify-content-between">
              <h5>Update Transaction</h5>
              <IoClose
                onClick={() => {
                  setOpen(false);
                  setSelectedTransaction(null);
                }}
              />
            </div>
            <form className="row">
              <div className="form-group col-6">
                <label htmlFor="date">Date</label>
                <input
                  type="date"
                  id="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  disabled
                />
              </div>
              <div className="form-group col-6">
                <label htmlFor="customerName">Select Account</label>
                <input
                  type="text"
                  id="customerName"
                  className="form-control"
                  value={selectedTransaction?.customer__name}
                  disabled
                />
              </div>
              <div className="form-group col-6">
                <label htmlFor="debit">Debit</label>
                <input
                  type="number"
                  id="debit"
                  className="form-control"
                  value={debitValue}
                  onChange={(e) => setDebitValue(e.target.value)}
                  disabled={!!creditValue}
                />
              </div>
              <div className="form-group col-6">
                <label htmlFor="Credit">Credit</label>
                <input
                  type="number"
                  id="Credit"
                  className="form-control"
                  value={creditValue}
                  onChange={(e) => setCreditValue(e.target.value)}
                  disabled={!!debitValue}
                />
              </div>
              <div className="form-group">
                <label htmlFor="details">Details</label>
                <textarea
                  className="form-control"
                  id="details"
                  rows="3"
                  value={details}
                  onChange={(e) => setDetails(e.target.value)}
                ></textarea>
              </div>
            </form>
            <div className="button-wrapper text-right">
              <button
                className="btn"
                onClick={() => {
                  setOpen(false);
                  setSelectedTransaction(null);
                }}
              >
                Cancel
              </button>
              <button
                className="btn"
                onClick={() => setOpen2((open2) => !open2)}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </Popup>
      <Popup
        open={open2}
        closeOnDocumentClick={false}
        onClose={closeModal}
        className="new-user journal-pop"
      >
        <div className="card">
          <div className="card-body">
            <div className="flex align-items-center justify-content-between">
              <h5 className="pb-4">Enter Pin</h5>
            </div>
            <div className="otp-wrapper">
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={" "}
                inputType="password"
                renderInput={(props) => <input {...props} />}
              />
            </div>
            <div className="button-wrapper text-right">
              <button className="btn" onClick={closeModal2}>
                Cancel
              </button>
              <button className="btn" onClick={handleVerifyPin}>
                Update
              </button>
            </div>
          </div>
        </div>
      </Popup>
      <Popup
        open={isProfilePopUp}
        closeOnDocumentClick={false}
        onClose={closeProfile}
        className="new-user journal-pop"
      >
        <div className="card">
          <div className="card-body">
            <div className="flex align-items-center justify-content-between">
              <h5>Edit Customer</h5>
              <IoClose onClick={closeProfile} />
            </div>
            <form>
              <div className="form-group title-input">
                <label htmlFor="name">Full Name *</label>
                <div className="d-flex align-items-center">
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                  >
                    <option value="1">Mr.</option>
                    <option value="2">Mrs.</option>
                  </select>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder="Enter Full Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="phone">Mobile Number</label>
                <input
                  type="number"
                  id="phone"
                  className="form-control"
                  placeholder="Mobile Number"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {formData.phone && !isValidPhone(formData.phone) && (
                  <small className="text-danger">
                    Please enter a valid 10-digit phone number.
                  </small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {formData.email && !isValidEmail(formData.email) && (
                  <small className="text-danger">
                    Please enter a valid email address.
                  </small>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="details">Details</label>
                <textarea
                  className="form-control"
                  id="details"
                  rows="3"
                  value={formData.details}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="button-wrapper btnPrimary text-right">
                <button
                  type="button"
                  className="btn"
                  onClick={handleCustomerData}
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </Popup>
    </>
  );
}

export default CustomerTransactions;
